import { cn } from '@/lib/utils';

/** Rodapé da tabela: seletor de itens, contagem no centro, páginas de 38px à direita. */
export const GridPagination: React.FC<{
  page: number;
  pages: number;
  perPage: number;
  perPageOptions?: number[];
  total: number;
  onPage: (p: number) => void;
  onPerPage?: (p: number) => void;
}> = ({
  page,
  pages,
  perPage,
  perPageOptions = [10, 25, 50, 100],
  total,
  onPage,
  onPerPage,
}) => {
  const from = total > 0 ? (page - 1) * perPage + 1 : 0;
  const to = Math.min(page * perPage, total);

  const box =
    'flex size-[38px] items-center justify-center rounded-[10px] border text-[13px] transition-all duration-150';

  const windowStart = Math.max(1, Math.min(page - 1, pages - 2));
  const pageNumbers = Array.from(
    { length: Math.min(pages, 3) },
    (_, i) => windowStart + i,
  ).filter((n) => n >= 1 && n <= pages);

  return (
    <div className="flex flex-col items-center gap-3.5 px-[22px] py-4 sm:flex-row">
      <span className="flex items-center gap-2.5">
        <span className="col-label text-[10.5px] text-faint">Itens</span>
        <select
          value={perPage}
          onChange={(e) => onPerPage?.(Number(e.target.value))}
          className="h-[38px] cursor-pointer appearance-none rounded-[11px] border border-border bg-field px-3.5 text-[13px] font-semibold text-foreground outline-none"
        >
          {perPageOptions.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </span>

      <span className="text-[12.5px] text-muted-foreground sm:mx-auto">
        {from}&ndash;{to} de {total}
      </span>

      <span className="flex flex-wrap justify-center gap-[7px]">
        <button
          type="button"
          onClick={() => onPage(page - 1)}
          disabled={page <= 1}
          className={cn(
            box,
            'cursor-pointer border-border text-faint hover:border-ring hover:bg-raised disabled:pointer-events-none disabled:opacity-40',
          )}
        >
          &lsaquo;
        </button>
        {pageNumbers.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => onPage(n)}
            className={cn(
              box,
              n === page
                ? 'font-display border-olive-line bg-accent font-extrabold text-olive-ink'
                : 'cursor-pointer border-border font-semibold text-muted-foreground hover:border-ring hover:bg-raised',
            )}
          >
            {n}
          </button>
        ))}
        <button
          type="button"
          onClick={() => onPage(page + 1)}
          disabled={page >= pages}
          className={cn(
            box,
            'cursor-pointer border-border text-muted-foreground hover:border-ring hover:bg-raised disabled:pointer-events-none disabled:opacity-40',
          )}
        >
          &rsaquo;
        </button>
      </span>
    </div>
  );
};
